@let header = i18n.translations().header;
<header class="header">
  <nav class="header__nav" [attr.aria-label]="header.navAriaLabel">
    <a routerLink="/" class="header__logo" [attr.aria-label]="header.logoAriaLabel">
      <img
        ngSrc="assets/img/angular_whiteTransparent.svg"
        alt=""
        class="header__logo-img"
        width="32"
        height="32"
      />
      <span class="header__logo-text">loiane.training</span>
    </a>

    <!-- Desktop Navigation -->
    <ul class="header__links">
      <li>
        <a routerLink="/cursos" routerLinkActive="header__link--active" class="header__link">
          {{ header.courses }}
        </a>
      </li>
      <li>
        <a routerLink="/ajuda" routerLinkActive="header__link--active" class="header__link">
          {{ header.help }}
        </a>
      </li>
      <li>
        <a routerLink="/sobre" routerLinkActive="header__link--active" class="header__link">
          {{ header.about }}
        </a>
      </li>

      @if (currentUser()) {
        <li>
          <a
            routerLink="/dashboard"
            routerLinkActive="header__link--active"
            class="header__link"
          >
            {{ header.myProfile }}
          </a>
        </li>
        <li>
          <button
            (click)="logout()"
            class="header__link header__link--logout"
          >
            {{ header.logout }}
          </button>
        </li>
      } @else {
        <li>
          <a
            routerLink="/sessao/criar-conta"
            routerLinkActive="header__link--active"
            class="header__link"
          >
            {{ header.register }}
          </a>
        </li>
        <li>
          <a
            routerLink="/sessao/login"
            routerLinkActive="header__link--active"
            class="header__link header__link--login"
          >
            {{ header.login }}
          </a>
        </li>
      }

      <li>
        <app-language-switcher />
      </li>
    </ul>

    <!-- Mobile Menu Button -->
    @defer (on interaction) {
      <button
        mat-icon-button
        [matMenuTriggerFor]="mobileMenu"
        class="header__menu-btn"
        [attr.aria-label]="header.openMenu"
      >
        <mat-icon>menu</mat-icon>
      </button>

      <!-- Mobile Menu -->
      <mat-menu #mobileMenu="matMenu" class="header__mobile-menu">
        <a mat-menu-item routerLink="/cursos">{{ header.courses }}</a>
        <a mat-menu-item routerLink="/ajuda">{{ header.help }}</a>
        <a mat-menu-item routerLink="/sobre">{{ header.about }}</a>

        <mat-divider />

        @if (currentUser()) {
          <a mat-menu-item routerLink="/dashboard">{{ header.myProfile }}</a>
          <button mat-menu-item (click)="logout()">{{ header.logout }}</button>
        } @else {
          <a mat-menu-item routerLink="/sessao/criar-conta">{{ header.register }}</a>
          <a mat-menu-item routerLink="/sessao/login">{{ header.login }}</a>
        }

        <mat-divider />
        <div mat-menu-item class="header__mobile-lang" (click)="$event.stopPropagation()">
          <app-language-switcher />
        </div>
      </mat-menu>
    } @placeholder {
      <button
        class="header__menu-btn header__menu-btn--placeholder"
        [attr.aria-label]="header.openMenu"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
        </svg>
      </button>
    }
  </nav>
</header>
